import { forwardRef } from 'react';
import SanitizedHTML from 'react-sanitized-html';
import { SANITIZE_HTML_DEFAULT_TAGS } from '../../../../../../../config/constants';
import { usePlanCtx } from '../../../planDetailsContext';
import { SectionConatiner } from '../../ui-blocks/containers';
import { SectionHeading } from '../../ui-blocks/typograpghy';
import { ISection } from '../types';
import classes from './index.module.css';

const SeoContent: React.FC<ISection> = forwardRef(
  ({ id, name }, ref: React.ForwardedRef<HTMLDivElement>) => {
    const planDetails = usePlanCtx();

    return (
      <div data-testid={id} id={id} ref={ref}>
        {name && planDetails.seoContentBlock ? (
          <SectionConatiner>
            <SectionHeading>{name}</SectionHeading>
            <div className={classes.MainLayout}>
              <SanitizedHTML
                allowedTags={[...SANITIZE_HTML_DEFAULT_TAGS, 'img']}
                html={planDetails.seoContentBlock}
              ></SanitizedHTML>
            </div>
          </SectionConatiner>
        ) : null}
      </div>
    );
  }
);

export { SeoContent };
